const VideoFileIcon = ({ className }: { className?: string }) => {
  return (
    <span className={className}>
      <svg width="32" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19.3164 3.9082L15.9082 0.5H13.0664L16.4746 3.9082H19.3164ZM1.1377 0.5H0V3.9082H4.5459L1.1377 0.5ZM11.9336 3.9082L8.52051 0.5H5.67871L9.08691 3.9082H11.9336ZM20.4541 8.4541H15.9082L19.3164 5.0459H16.4746L13.0664 8.4541H8.52051L11.9287 5.0459H9.08691L5.67871 8.4541H1.1377L4.5459 5.0459H0V23.2295C0 24.4795 1.02051 25.5 2.27051 25.5H22.7246C23.9795 25.5 24.9951 24.4795 24.9951 23.2295V5.0459H23.8574L20.4541 8.4541ZM9.0918 22.0918V11.8623L18.1836 16.9746L9.0918 22.0918ZM20.4541 0.5L23.8623 3.9082H25V0.5H20.4541Z"
          fill="black"
        />
      </svg>
    </span>
  );
};

export default VideoFileIcon;
